module.exports = __webpack_public_path__ + "static/media/restservice.4e81d702.svg";